import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import { useLang } from '~/hooks/useLang'

export default function SearchAdvancedButton({
  canSearchAdvanced,
  searchAdvancedUrl,
}) {
  const { translate } = useLang()
  const ClickOpen = () => {
    window.open(
      searchAdvancedUrl,
      '_blank, width=auto, height=600, status = no'
    )
  }

  return (
    <Grid item>
      <Tooltip
        title={translate('See Search Advanced')}
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton disabled={!canSearchAdvanced} onClick={ClickOpen}>
            <ManageSearchIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>
  )
}
